import { string } from "prop-types"

export enum Themes {
  VINTAGE = 'vintage',
  MODERN = 'modern',
}


export type TMinimalDocumentMetadata = {
  id: string,

  title: string,
  type: string,
  number: number,
  year: number,
}

export enum EWindowState {
  MINIMIZED = 'minimized',
  MAXIMIZED = 'maximized',
  DEFAULT = 'default',
}

export type TWindowPosition = {
  x: number,
  y: number,
}

export type TWindowSize = {
  width: number,
  height: number,
}

export type TDocumentBase = {
  id: string,
  title: string,
}

export type TVirtualWindowData = {
  id: string,
  docId: string,
  anchorId?: string,
  title: string,
  isMaximized: boolean,
  position: TWindowPosition,
  size: TWindowSize,
  zIndex: number,
  focused?: boolean,
  customWindow?: boolean,
  innerSearch?: {
    text: string,
    index: number,
    matchCount?: number,
    caseSensitive?: boolean,
  },
  history: {
    docIds: string[],
    currentIndex: number,
  },
  showReds?: boolean,
}


export interface IMinimalApi {
  loadIndexByYearAndTypes: () => Promise<TDocumentTree>,
  loadDocTitlesForYearAndType: (year: number, type: string, count: number) => Promise<TLeaf[]>,

  loadIndexByYearAndMonitorNumber: () => Promise<TDocumentTree>,
  loadDocTitlesForYearAndMon: (year: number, mon_nr: number, date: string, count: number) => Promise<TLeaf[]>,

  loadReadLaterDocs: () => Promise<ReadLaterLeaf[]>,
  addReadLaterDoc: (docid: string) => Promise<void>,
  removeReadLaterDoc: (docid: string) => Promise<void>,

  loadBookmarkedDocs: () => Promise<BookmarkedLeaf[]>,
  addToBookmarks: (chainid: string) => Promise<void>,
  removeFromBookmarks: (chainid: string) => Promise<void>,

  loadDocumentById: (id: string, useLatestRevisionOnLinks?: boolean) => Promise<TDocument | undefined>,
  loadDocumentByLexId: (id: string) => Promise<TDocument | undefined>,

  getLatestDocs: () => Promise<TDocumentTree>,

  search: (filters: any, start?: number, size?: number, doAggs?: boolean, includeHtmlAndMarkdown?: boolean) => Promise<SearchLeaf[]>,

  updateUserTheme: (theme: Themes) => Promise<any>,

  docxgenForDoc: (id: string, hideReds?: boolean) => Promise<ArrayBuffer | undefined>,
  pdfgenForDoc: (id: string, hideReds?: boolean) => Promise<ArrayBuffer | undefined>,
  docxgenForHTML: (html: string) => Promise<ArrayBuffer | undefined>,
  pdfgenForHTML: (html: string) => Promise<ArrayBuffer | undefined>,
}

export enum ENodeTypes {
  NODE = 'node',
  LEAF = 'leaf',
}

export type TMeta = {
  _id: string,
  title: string,

  issue_year: number,
  year: number,
  issuer_nr: number,
  issuer_name: string,
  type: string,
  rev_type: string,
  status_code: number,
  status_name: string,

  nr?: number,
}

// Index Years / Index Mons
export type TLeaf = {
  type: ENodeTypes.LEAF,
  collapsed: true, // ??
  nodeClass: string,
  data: TMeta, // document metadata
}

export type TLatestLeaf = {
  type: ENodeTypes.LEAF,
  collapsed: true, // ??
  nodeClass: string,
  data: {
    issue_year: number,
    issuer: string,
    nr: number,
    rev_type: string,
    status_code: string,
    status_name: string,
    title: string,
    type: string,
    year: number,
    _id: string,
  }
}

export type ReadLaterLeaf = TLeaf & {
  data: {
    _id: string,
    title: string
  }
}

export type SearchLeaf = ReadLaterLeaf;

export type BookmarkedLeaf = ReadLaterLeaf;

export type TNode = {
  type: ENodeTypes.NODE,
  nodeClass: string,
  depth: number,
  title: string,
  collapsed: boolean, // DO I NEED THIS???? mybe in the UI only
  doc_count: number,
  children: (TNode | TLeaf | ReadLaterLeaf)[],
  loadArgs?: any[],
}

export type TDocumentTree = (TNode | TLeaf | ReadLaterLeaf)[];

export type TDocumentRel = {
  desc: string,
  rel_code: number,
  other_id: string,
  other_lexid: string,
  other_doc: {
    issue_year: number,
    issuers: {
      issuer_code: number,
      issuer_name: string,
      issuer_nr: number,
    }[],
    newtype: string,
    revdata: { // TODO - type possibly already exists
      chain_id: string,
      next_rev_date: string,
      prev_rev_date: string,
      rev_date: string,
      rev_number: number,
      rev_type: string,
    },
    status_code: string,
    status_name: string,
    title: string,
  }
}

export type TDocument = {
  created: string,
  ctime: string,
  deleted: boolean,
  docid: string,
  anchorId?: string,
  domains: { domain_name: string, domain_code: string }[],
  end_date: string,
  history: any[],
  html: string,
  issue_date: string,
  issue_year: number,
  issuers: { issuer_nr: number, issuer_code: number, issuer_name: string }[],
  lexid: string,
  modified: string,
  mtime: string,
  newtype: string,
  parsed: boolean,
  publish_date: string,
  publish_nr: number,
  publish_year: number,
  publisher_name: string,
  relations: TDocumentRel[],
  revdata: {
    chain_id: string,
    next_rev_date: string,
    prev_rev_date: string,
    rev_date: string,
    rev_number: number,
    rev_type: string,
  },
  reviewed: boolean,
  revisions: { id: string, lexid: string, rev_date: string, rev_type: string }[],
  status_code: string,
  status_name: string,
  title: string,
  tracked: boolean,
  type_code: number,
  type_name: string,
}


export type OptionType = {
  value: string,
  label: string,
}

export const ULTIMELE_APARITII_WINDOW_ID = 'ultimele-aparitii';
